import React from "react";

import CloseIcon from "@material-ui/icons/Close";

import { EventEditorState } from "./EventEditor";

type EventEditorHeaderActionProps = {
  editorState: EventEditorState;
  onClose: () => void;
};

function EventEditorHeaderAction({
  editorState,
  onClose,
}: EventEditorHeaderActionProps) {
  return (
    <div aria-label="info" className="text-xs text-grey-600">
      <div style={{ display: "inline-block" }}>
        {editorState.created_at && (
          <>
            <span className="font-bold mr-3">Created:</span>
            {new Date(editorState.created_at).toLocaleString()}
            {editorState.created_by && (
              <>
                &nbsp;by&nbsp;
                {editorState.created_by}
              </>
            )}
            <br />
          </>
        )}
        {editorState.updated_at && (
          <>
            <span className="font-bold mr-2">Updated:</span>
            {new Date(editorState.updated_at).toLocaleString()}
            {editorState.last_updated_by && (
              <>
                &nbsp;by&nbsp;
                {editorState.last_updated_by}
              </>
            )}
          </>
        )}
      </div>
      <CloseIcon
        style={{
          cursor: "pointer",
          position: "relative",
          transform: "translate(0, -10px)",
          marginLeft: "15px",
        }}
        onClick={onClose}
      />
    </div>
  );
}

export default EventEditorHeaderAction;
